import React, { useState } from "react";

const useObjectSorting = () => {
  const [selectedTypes, setSelectedTypes] = useState([]); //{type: bool, type: bool, ...}
  const [foundObjects, setFoundObjects] = useState([]);
  const [displayObjects, setDisplayObjects] = useState([]);

  const addRemoveSelectedType = (type) => {
    if (selectedTypes.includes(type)) {
      setSelectedTypes(selectedTypes.filter((t) => t != type));
    } else setSelectedTypes([...selectedTypes, type]);
  };
  return { element: <div>useObjectSorting</div> };
};

export default useObjectSorting;
